import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react';

import { descDateSort } from '@common/helpers/declarative/sortings';
import { useTranslation } from '@common/hooks/translation';
import Pagination from '@common/components/pagination';
import SmartTable from '@common/components/smartTable';
import Loader from '@common/components/loader';
import { loadTransactionHistory } from '../../helper/loadTransactionHistory';
import {
  OTHER_ROWS, RESULT_PAGE_ITEM_COUNT, ROW_HEIGHT, transactionTabel,
} from '../../constants/transactionTabel';
import EmptyState from '../emptyState';

const TransactionHistory = ({ start, end }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const t = useTranslation();

  const getData = useCallback(async () => {
    if (!start || !end) return;

    setIsLoading(true);

    const resp = await loadTransactionHistory(start, end);
    setData(resp || []);

    setIsLoading(false);
  }, [start, end]);

  useEffect(() => {
    getData();
  }, [getData]);

  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = useRef(null);
  const bounding = tableRef.current?.getBoundingClientRect().top || 0;

  const resultItemsCount = Math.floor((window.innerHeight - bounding) / ROW_HEIGHT) - OTHER_ROWS || RESULT_PAGE_ITEM_COUNT;

  const [pageData, pageCount] = useMemo(() => {
    if (!data) return [[], 0];

    const listSorted = data.sort(descDateSort('created'));

    const listSliced = data.slice((currentPage - 1) * resultItemsCount, currentPage * resultItemsCount);

    return [listSliced, Math.ceil(listSorted.length / resultItemsCount)];
  }, [data, currentPage]);

  if (isLoading) return <Loader />;

  if (!data.length) return <EmptyState />;

  return (
    <div className="r-p-table-wrp" ref={tableRef}>
      <div className="r-p-table-inner">
        <div className="results-page-middle">
          <SmartTable columnConfig={transactionTabel(t)} data={pageData} />
        </div>
        <div className="results-page-bottom">
          <Pagination currentPage={currentPage} pageCount={pageCount} onPageChange={setCurrentPage} />
        </div>
      </div>
    </div>
  );
};

export default TransactionHistory;
